export const CardFadeOverlay = () => (
  <div className="t-pointer-events-none t-absolute t-inset-x-0 t-bottom-0 t-z-10 t-h-10 t-rounded-b-2xl t-bg-card-bottom-fade" />
);
